import { render, staticRenderFns } from "./IconsPage.vue?vue&type=template&id=c5c08828&scoped=true&"
import script from "./IconsPage.vue?vue&type=script&lang=js&"
export * from "./IconsPage.vue?vue&type=script&lang=js&"
import style0 from "./IconsPage.vue?vue&type=style&index=0&id=c5c08828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c08828",
  null
  
)

export default component.exports